export type All = 'ALL';
export type First = 'FIRST';
export type Last = 'LAST';
export type Target = 'TARGET';
export type Keyword = 'KEYWORD';
export type Order = 'ORDER';
export type Row = 'ROW';
export type Column = 'COLUMN';
export type Cell = 'CELL';
export type Custom = 'CUSTOM';
export type RowColumn = 'ROW_COLUMN';
export type Up = 'UP';
export type Down = 'DOWN';
export type Left = 'LEFT';
export type Right = 'RIGHT';
export type Positive = 'POSITIVE';
export type Negative = 'NEGATIVE';

export interface IOffset<T> {
  direction: T;
  offset: number;
}
export interface IPosition<T> {
  position_method: Keyword | Order;
  keyword?: string;
  offset_config: IOffset<T>;
}

export interface IRule {
  tag_code: string;
  position_type: 'ROW' | 'COLUMN' | 'CELL';
  row_content_config: {
    row_config: IPosition<Up | Down>;
    colum_range_config: {
      range_type: All | Custom;
      begin: IPosition<Left | Right>;
      end: IPosition<Left | Right>;
    };
  };
  col_content_config: {
    colum_config: IPosition<Left | Right>;
    row_range_config: {
      range_type: All | Custom;
      begin: IPosition<Positive | Negative | Up | Down>;
      end: IPosition<Positive | Negative | Up | Down>;
    };
  };
  cell_content_config: {
    left_right_offset: IOffset<Left | Right>;
    up_down_offset: IOffset<Up | Down>;
    grid_position: Keyword | RowColumn;
    keyword: string;
    row_config: IPosition<Up | Down>;
    colum_config: IPosition<Left | Right>;
  };
}

export interface IFormValue {
  extraction_range: All | First | Last | Target;
  pages?: string;
  is_cross_page: boolean;
  table_order_type: Keyword | Order;
  // ? keywords和table_order应该是互斥的
  keywords?: string;
  table_order?: IOffset<Positive | Negative>;
  rules: IRule[];
}
/**
 * 抽取范围
 */
export const ExtractionRangeEnum = {
  ALL: 'ALL',
  FIRST: 'FIRST',
  LAST: 'LAST',
  TARGET: 'TARGET',
} as const;
